/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './trialEndModal.tpl.html';

/**
 * Module for the trial end modal.
 */
angular
  .module('shared.trialendmodal', [])
  /**
   * Trial End Modal controller for the TrialEndModal.tpl.html template.
   */
  .controller('TrialEndModalCtrl', function ($scope, $state, $uibModalInstance, configService, accountUtils, $window) {
    /**
     * Function to cancel out of the model.
     */
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    /**
     * Function to redirect the app to the self service payment.
     */
    $scope.upgrade = function () {
      Promise.all([configService.getBillingUrls(), accountUtils.getOrgInfo()]).then(([billing, orgInfo]) => {
        let selfServiceAddress;
        if (!orgInfo.reseller) {
          selfServiceAddress = billing.kaseyaPortalRegistrationLink;
        } else {
          selfServiceAddress = billing.kaseyaPortalLink;
        }
        $window.open(selfServiceAddress, '_blank');
      });
    };
  });
